const actions = {
  GET_CUSTOMER_PARAMERTERS: 'GET_CUSTOMER_PARAMERTERS',
  GET_CUSTOMER_PARAMERTERS_SUCCESS: 'GET_CUSTOMER_PARAMERTERS_SUCCESS',
  GET_CUSTOMER_PARAMERTERS_FAILED: 'GET_CUSTOMER_PARAMERTERS_FAILED',


  getCustomerParameters: () => ({
    type: actions.GET_CUSTOMER_PARAMERTERS,
  }),
  getCustomerParametersSuccess: (data) => ({
    type: actions.GET_CUSTOMER_PARAMERTERS_SUCCESS,
    payload: { data },
  }),
  getCustomerParametersFailed: (error) => ({
    type: actions.GET_CUSTOMER_PARAMERTERS_FAILED,
    payload: { error },
  }),

};

export default actions;
